<template>
    <div :class="parentContainerClass" v-if="accountCodeType">
        <div :class="accountCodeContainerClass">
            <form-group attribute="Account Code" name="accountCode" label="Account Code">
                <account-code-options
                    v-model="accountCode"
                    :selected="accountCode"
                    :is-update="isUpdate"
                    :account-code-type="accountCodeType"
                    @optionSelected="handleAccountCodeChanged"
                    @optionDescriptionSelected="handleAccountDescriptionChanged"
                />
            </form-group>
        </div>

        <div :class="accountCodeDescriptionContainerClass">
            <form-group
                v-if="accountCode !== null"
                name="accountCodeDescription"
                label="Account Code Description"
                attribute="Account Code Description"
            >
                <md-input disabled v-model="accountCodeDescription" />
            </form-group>
        </div>
    </div>
</template>
<script>
import AccountCodeOptions from './AccountCodeOptions';

export default {
    name: 'AccountCodeDescriptionGroup',
    components: { AccountCodeOptions },
    props: {
        accountCode: {
            type: String,
            default: null
        },
        accountCodeDescription: {
            type: String,
            default: null
        },
        accountCodeContainerClass: {
            type: String,
            default: null
        },
        accountCodeDescriptionContainerClass: {
            type: String,
            default: null
        },
        parentContainerClass: {
            type: String,
            default: null
        },
        isUpdate: { type: Boolean, default: false },
        accountCodeType: {
            type: String,
            default: 'expense'
        }
    },
    methods: {
        handleAccountCodeChanged(value) {
            this.$emit('optionSelected', value);
        },
        handleAccountDescriptionChanged(value) {
            this.$emit('optionDescriptionSelected', value);
        }
    }
};
</script>
<style scoped>
.md-size-50 {
    padding: 0 15px !important;
}
</style>
